var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from '@mui/material';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import { uploadFile } from '@src/app/pages/JobPage/Job/Job.requests';
import { useBankTransfer } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { groupTransfer } from '@src/app/pages/TransferPage/Transfer/Transfer.requests';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import FileFormik from '@src/components/Atoms/Formik/Input/FileFormik';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import SelectFormik from '@src/components/Atoms/Formik/Select/SelectFormik';
import TextAreaFormik from '@src/components/Atoms/Formik/TextArea/TextAreaFormik';
import { useFormik } from 'formik';
import { useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { dummyNpwpStatusOptions, dummyTaxMethodOptions, dummyTaxOptions, dummyTaxTypeOptions, dummyTransferMethodGroupOptions, StatusOptions, } from '../Transfer/Transfer.constant';
import { PajakCategory, PajakType } from '../Transfer/Transfer.enum';
import { NpwpStatus } from './Transfer.enum';
var JobProcessFormSchema = Yup.object().shape({
    pajakType: Yup.string().required('Field belum diisi'),
    npwpStatus: Yup.string().required('Field belum diisi'),
    npwpNumber: Yup.string().when('npwpStatus', {
        is: function (npwpStatus) { return npwpStatus === 'have-npwp'; },
        then: Yup.string()
            .required('Field belum diisi')
            .matches(/^\d{2}\.\d{3}\.\d{3}.\d{1}-\d{3}\.\d{3,}$/, 'NPWP minimal 15 digit'),
    }),
    pajakMethod: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakCategory: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakBruto: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakFee: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakPPN: Yup.string().when(['pajakType', 'pajakCategory'], {
        is: function (pajakType, pajakCategory) {
            return pajakType === PajakType.PAJAK && pajakCategory === PajakCategory.PPH23PLUSPPN;
        },
        then: Yup.string().required('Field belum diisi'),
    }),
    transferMethod: Yup.string().required('Field belum diisi'),
    termStatus: Yup.string().required('Field belum diisi'),
    bankTransferByPubId: Yup.string().required('Field belum diisi'),
});
var ProcessTransferByGroup = function (_a) {
    var isOpen = _a.isOpen, handleClose = _a.handleClose, allrecords = _a.allrecords, record = _a.record, refetch = _a.refetch;
    var jobInitialValues = {
        talentBankAccountPubId: '',
        proofTransferFilePubId: {},
        totalTransferredFee: '',
        pajakType: '',
        npwpStatus: '',
        npwpNumber: '',
        pajakMethod: '',
        pajakCategory: '',
        pajakBruto: '',
        pajakFee: '',
        pajakPPN: '',
        termNote: '',
        termStatus: '',
        transferMethod: '',
        bankTransferByPubId: '',
    };
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState({
        proofTransferFilePubId: '',
    }), files = _c[0], setFiles = _c[1];
    var _d = useState(jobInitialValues), initialFormValues = _d[0], setInitialFormValues = _d[1];
    var _e = useBankTransfer(), bankTransfer = _e.bankTransfer, isLoadingBankTransfer = _e.isLoading;
    var optionBankTransfer = bankTransfer &&
        bankTransfer.data.length > 0 &&
        bankTransfer.data.map(function (bank) { return ({
            name: bank.name,
            value: bank.pubId,
        }); });
    var onChangeFiles = function (e) {
        var _a;
        setFiles(__assign(__assign({}, files), (_a = {}, _a[e.target.name] = e.target.files, _a)));
        TransferProcessFormik.setFieldValue(e.target.name, e.target.files);
    };
    var TransferProcessFormik = useFormik({
        enableReinitialize: true,
        initialValues: initialFormValues,
        validationSchema: JobProcessFormSchema,
        onSubmit: function (values, _a) {
            var setErrors = _a.setErrors, setStatus = _a.setStatus, setSubmitting = _a.setSubmitting;
            return __awaiter(void 0, void 0, void 0, function () {
                var pubIds, transferProof, proofData, talentBankAccountPubId, totalTransferredFee, pajakType, pajakBruto, pajakCategory, npwpNumber, pajakMethod, pajakFee, pajakPPN, value, finalPajakFee, finalPajakPPN, finalPajakBruto, finaltotalTransferredFee, finalFormValue, pajakFormValue, pajakPPNFormValue, finalFormData, status_1, e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setLoading(true);
                            pubIds = record &&
                                record.length > 0 &&
                                record.map(function (rec) {
                                    return rec.job.pubId;
                                });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 5, 6, 7]);
                            transferProof = '';
                            if (!values.proofTransferFilePubId[0]) return [3 /*break*/, 3];
                            return [4 /*yield*/, uploadFile({
                                    File: files.proofTransferFilePubId[0],
                                    TenantPubId: record[0].job.talent.tenant.pubId,
                                    TalentPubId: record[0].job.talent.pubId,
                                    Type: 'ProofOfTransfers',
                                })];
                        case 2:
                            proofData = (_b.sent()).data;
                            if (proofData.code === 200) {
                                transferProof = proofData.data.pubId;
                            }
                            _b.label = 3;
                        case 3:
                            talentBankAccountPubId = values.talentBankAccountPubId, totalTransferredFee = values.totalTransferredFee, pajakType = values.pajakType, pajakBruto = values.pajakBruto, pajakCategory = values.pajakCategory, npwpNumber = values.npwpNumber, pajakMethod = values.pajakMethod, pajakFee = values.pajakFee, pajakPPN = values.pajakPPN, value = __rest(values, ["talentBankAccountPubId", "totalTransferredFee", "pajakType", "pajakBruto", "pajakCategory", "npwpNumber", "pajakMethod", "pajakFee", "pajakPPN"]);
                            finalPajakFee = pajakFee ? pajakFee.replace(/\./g, '') : '';
                            finalPajakPPN = pajakPPN ? pajakPPN.replace(/\./g, '') : '';
                            finalPajakBruto = pajakBruto ? pajakBruto.replace(/\./g, '') : '';
                            finaltotalTransferredFee = totalTransferredFee
                                ? totalTransferredFee.replace(/\./g, '')
                                : '';
                            finalFormValue = value;
                            pajakFormValue = {};
                            pajakPPNFormValue = {};
                            if (pajakType === PajakType.PAJAK) {
                                pajakFormValue = {
                                    pajakType: pajakType,
                                    npwpNumber: npwpNumber,
                                    pajakMethod: pajakMethod,
                                    pajakCategory: pajakCategory,
                                    pajakFee: finalPajakFee,
                                    pajakBruto: finalPajakBruto,
                                    totalTransferredFee: finaltotalTransferredFee,
                                };
                            }
                            else {
                                pajakFormValue = {
                                    pajakType: pajakType,
                                };
                            }
                            if (pajakType === PajakType.PAJAK && pajakCategory === PajakCategory.PPH23PLUSPPN) {
                                pajakPPNFormValue = {
                                    pajakPPN: finalPajakPPN,
                                };
                            }
                            finalFormData = __assign(__assign(__assign(__assign({}, finalFormValue), pajakFormValue), pajakPPNFormValue), { proofTransferFilePubId: transferProof, jobPubIds: pubIds });
                            return [4 /*yield*/, groupTransfer(finalFormData)];
                        case 4:
                            status_1 = (_b.sent()).status;
                            if (status_1 === 200) {
                                toast.success('Transfer as Group berhasil ');
                            }
                            else {
                                toast.error('Transfer as Group gagal');
                            }
                            allrecords([]); //delete selected record
                            return [3 /*break*/, 7];
                        case 5:
                            e_1 = _b.sent();
                            error = e_1.response.data;
                            setStatus(error.message);
                            setErrors(error.message);
                            toast.error(error.message);
                            return [3 /*break*/, 7];
                        case 6:
                            setSubmitting(false);
                            setLoading(false);
                            handleClose();
                            refetch();
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
    });
    return (_jsx(DrawerComponent, __assign({ open: isOpen, size: 'LG', handleClose: handleClose, title: 'Process Transfer secara Grup' }, { children: record && record.length > 0 && (_jsxs("div", { children: [_jsxs("div", { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Pajak Status', name: 'pajakType', formik: TransferProcessFormik, optionList: dummyTaxOptions, isRequired: true }) })), TransferProcessFormik.values.pajakType === PajakType.PAJAK && (_jsxs(_Fragment, { children: [_jsx(SelectFormik, { label: 'NPWP Status', name: 'npwpStatus', formik: TransferProcessFormik, optionList: dummyNpwpStatusOptions, isRequired: true }), TransferProcessFormik.values.npwpStatus === NpwpStatus.NPWP && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'No NPWP', type: 'text', placeholder: 'No NPWP', name: 'npwpNumber', formik: TransferProcessFormik, isRequired: true, isNPWP: true }) })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Metode Pajak', name: 'pajakMethod', formik: TransferProcessFormik, optionList: dummyTaxMethodOptions, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Jenis Pajak', name: 'pajakCategory', formik: TransferProcessFormik, optionList: dummyTaxTypeOptions, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Bruto', type: 'text', placeholder: 'Bruto', name: 'pajakBruto', formik: TransferProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Pajak PPH', type: 'text', placeholder: 'Pajak PPH', name: 'pajakFee', formik: TransferProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) })), TransferProcessFormik.values.pajakType === PajakType.PAJAK &&
                                    TransferProcessFormik.values.pajakCategory === PajakCategory.PPH23PLUSPPN && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Pajak PPN', type: 'text', placeholder: 'Pajak PPN', name: 'pajakPPN', formik: TransferProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) }))), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Fee Ditransfer', type: 'text', placeholder: 'Fee Ditransfer', name: 'totalTransferredFee', formik: TransferProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) }))] }))] }), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(SelectFormik, { label: 'Metode Transfer', name: 'transferMethod', formik: TransferProcessFormik, optionList: dummyTransferMethodGroupOptions, isRequired: true }), _jsx(SelectFormik, { label: 'Term Status', name: 'termStatus', formik: TransferProcessFormik, optionList: StatusOptions, isRequired: true }), _jsx(TextAreaFormik, { label: 'Note', placeholder: 'Note', name: "termNote", formik: TransferProcessFormik })] })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(FileFormik, { label: 'File', placeholder: 'File', name: 'proofTransferFilePubId', formik: TransferProcessFormik, onChange: onChangeFiles }) })), _jsx(Divider, {}), !isLoadingBankTransfer && optionBankTransfer && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Transfer dari', name: 'bankTransferByPubId', isRequired: true, formik: TransferProcessFormik, optionList: optionBankTransfer }) }))), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: handleClose, disabled: TransferProcessFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: _jsx("span", __assign({ className: 'indicator-label' }, { children: "Batal" })) })), _jsxs("button", __assign({ type: 'button', onClick: function () { return TransferProcessFormik.handleSubmit(); }, className: 'btn btn-primary btn-sm' }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })));
};
export default ProcessTransferByGroup;
